import React, { useState } from 'react';
import './RecipeCard.css';

export default function RecipeCard({ meal, onClick, index }) {
  const [imgError, setImgError] = useState(false);

  return (
    <article
      className="recipe-card"
      onClick={() => onClick(meal)}
      style={{ animationDelay: `${index * 60}ms` }}
      tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && onClick(meal)}
      role="button"
      aria-label={`View recipe for ${meal.strMeal}`}
    >
      <div className="card-image-wrap">
        {!imgError ? (
          <img
            src={meal.strMealThumb}
            alt={meal.strMeal}
            className="card-image"
            loading="lazy"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="card-image-fallback">
            <span>🍽️</span>
          </div>
        )}
        <div className="card-overlay" />
        {meal.strCategory && (
          <span className="card-category">{meal.strCategory}</span>
        )}
      </div>
      <div className="card-body">
        <h3 className="card-title">{meal.strMeal}</h3>
        <div className="card-meta">
          {meal.strArea && (
            <span className="card-area">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
              {meal.strArea}
            </span>
          )}
          {meal.strTags && (
            <span className="card-tag">{meal.strTags.split(',')[0]}</span>
          )}
        </div>
        <button className="card-btn" tabIndex={-1}>
          View Recipe
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </button>
      </div>
    </article>
  );
}
